// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2nFFcF","iconContainer":"_3IumoI","iconContainerCompleted":"_3l5GWs","icon":"_2CYPsZ","preTitle":"PXZ224"};